import { BasicColumnTypes } from '@opengov/ogql-types';

import { ECalculationDateFormats } from '../../basicCalculation/types';

export enum EAllowedConditionalTypes {
  Currency = 'currency',
  Date = 'date',
  Numeric = 'numeric',
  Percent = 'percentage',
  DayInterval = 'dayInterval',
  YearInterval = 'yearInterval'
}

export enum EConditionalCustomValues {
  Numeric = 'custom_value_numeric',
  Currency = 'custom_value_currency',
  Percentage = 'custom_value_percentage',
  Year = 'custom_value_year',
  Date = 'custom_value_date'
}

export const ConditionalColumnTypeSecondaryLabels = {
  [BasicColumnTypes.Numeric]: '#',
  [BasicColumnTypes.Percent]: '%',
  [BasicColumnTypes.Currency]: '$',
  [ECalculationDateFormats.Year]: 'YYYY',
  [ECalculationDateFormats.YearMonth]: 'MM-YYYY',
  [ECalculationDateFormats.YearMonthDay]: 'MM-DD-YYYY'
};
